import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import NavBar from '../Common/Navbar'
import Pricing from '../Home/Pricing';
import Work from '../Home/Work';
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '../Home/TopButton';

function Price() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>Pricing Plan</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/pricing">Pricing</Link>
                    </div>
                </div>
            </div>
            <Pricing />
            <Work />
            <FooterMenu />
            <Copyright />
            <TopButton />
        </>
    )
}

export default Price
